// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2usWv","colCheckbox":"styles_colCheckbox__3AQ3p"};